const profile = {
  firstName: 'Murat',
  name: 'Murat Selcukoglu',
  image: 'profil_1.png',
  email: 'muratselcukoglu55@gmail.com',
  phone: '+49 160 4994866',
  country: { de: 'Deutschland', en: 'Germany', tr: 'Almanya' },
  resumeDownload:
    'https://drive.google.com/file/d/1_LoaNdn9-Mo3TMSyA-IuEeI9lXPAgpSC/view?usp=sharing',
  social: [
    {
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/murat-s-960b5a230/',
      icon: 'linkedin',
    },
    {
      name: 'github',
      url: 'https://github.com/MuratSelcukoglu',
      icon: 'github',
    },
    {
      name: 'email',
      url: 'mailto:muratselcukoglu55@gmail.com',
      icon: 'mail',
    },
  ],
  skills: [
    { name: 'React Native', level: 100, category: 'mobile' },
    { name: 'React.js', level: 100, category: 'frontend' },
    { name: 'JavaScript', level: 100, category: 'language' },
    { name: 'TypeScript', level: 85, category: 'language' },
    { name: 'Redux / Redux Toolkit', level: 100, category: 'frontend' },
    { name: 'Expo', level: 95, category: 'mobile' },
    { name: 'React Navigation', level: 100, category: 'mobile' },
    { name: 'Next.js', level: 80, category: 'frontend' },
    { name: 'REST APIs', level: 100, category: 'backend' },
    { name: 'Git / GitHub', level: 100, category: 'tools' },
    { name: 'App Store & Play deployment', level: 100, category: 'mobile' },
    { name: 'UI / UX', level: 100, category: 'design' },
    { name: 'Figma (Design Handoff)', level: 85, category: 'design' },
    { name: 'Agile / Scrum', level: 90, category: 'tools' },
    { name: 'CSS / Tailwind', level: 95, category: 'design' },
    { name: 'HTML5', level: 95, category: 'design' },
    { name: 'C#', level: 70, category: 'language' },
    { name: 'ASP.NET MVC', level: 60, category: 'backend' },
    { name: 'MSSQL', level: 75, category: 'backend' },
  ],
  emailjs: {
    serviceId: 'service_069yogu',
    templateId: 'template_89oos18',
    publicKey: 'RnAyTSmAhe9ZaPalg',
  },
  companyLogos: {
    akinon: 'images/companies/akinon.svg',
  },
  companyUrls: {
    akinon: 'https://akinon.com',
  },
};

export default profile;
